module.exports = __webpack_public_path__ + "static/media/i5.2e7c5bf6.jpg";